import api from './api';

export interface WellnessTip {
  id: number;
  from_date: string;
  active: boolean;
  tip: string;
  tenant_id: number;
  created_at: string;
  updated_at: string;
}

export interface WellnessTipCreate {
  from_date: string;
  active: boolean;
  tip: string;
}

export interface WellnessTipUpdate {
  from_date?: string;
  active?: boolean;
  tip?: string;
}

export const wellnessTipService = {
  async getAll(tenantId?: number): Promise<WellnessTip[]> {
    const params = tenantId ? `?tenant_id=${tenantId}` : '';
    const response = await api.get(`/wellness-tips/${params}`);
    return response.data;
  },
  async create(tenantId: number, data: WellnessTipCreate): Promise<WellnessTip> {
    const response = await api.post(`/wellness-tips/?tenant_id=${tenantId}`, data);
    return response.data;
  },
  async update(id: number, data: WellnessTipUpdate): Promise<WellnessTip> {
    const response = await api.put(`/wellness-tips/${id}`, data);
    return response.data;
  },
  async delete(id: number): Promise<void> {
    await api.delete(`/wellness-tips/${id}`);
  },
};
